import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { useStringsContext } from '../../../contexts/strings';
import Button from '@mui/material/Button';
import MappingSelect from './mapping-select';
import { MappingSelectType } from './mappings-list';
import SceneHeader from '../../common/scene/scene-header';

interface Props {
  onAddRow: () => void;
  onSelectedType: (selectedType: MappingSelectType) => void;
}

function MappingsHeader({ onAddRow, onSelectedType }: Props) {
  const { strings } = useStringsContext();

  return (
    <SceneHeader title={strings.appBar.mappings}>
      <MappingSelect onSelectedType={onSelectedType} />
      <Button variant="contained" onClick={() => onAddRow()} startIcon={<AddIcon />}>
        {strings.mappings.addRow}
      </Button>
    </SceneHeader>
  );
}

export default MappingsHeader;
